import { render, staticRenderFns } from "./Obstacles.vue?vue&type=template&id=9e7aa8fe&scoped=true&"
import script from "./Obstacles.vue?vue&type=script&lang=js&"
export * from "./Obstacles.vue?vue&type=script&lang=js&"
import style0 from "./Obstacles.vue?vue&type=style&index=0&id=9e7aa8fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e7aa8fe",
  null
  
)

export default component.exports